const languages = [
	{
		id: 69,
		name: "Arabic",
		langCode: 'ar',
	},
	{
		id: 9,
		name: "Armenian",
		langCode: 'hy',
	},
	{
		id: 3,
		name: "Azerbaijani",
		code: 'az',
	},
	{
		id: 13,
		name: "Bulgarian",
		langCode: 'bg',
	},
	{
		id: 15,
		name: "Belarusian",
		langCode: 'be',
	},
	{
		id: 24,
		name: "Croatian",
		langCode: 'hr',
	},
	{
		id: 26,
		name: "Czech",
		langCode: 'cs',
	},
	{
		id: 27,
		name: "Danish",
		langCode: 'da',
	},
	{
		id: 56,
		name: "Dutch",
		langCode: 'nl',
	},
	{
		id: 88,
		name: "English",
		langCode: 'en',
		tfidf: true,
	},
	{
		id: 30,
		name: "Estonian",
		langCode: 'et',
	},
	{
		id: 31,
		name: "Finnish",
		langCode: 'fi',
	},
	{
		id: 32,
		name: "French",
		langCode: 'fr',
	},
	{
		id: 33,
		name: "German",
		langCode: 'de',
		tfidf: true,
	},
	{
		id: 35,
		name: "Greek",
		langCode: 'el',
	},
	{
		id: 38,
		name: "Hungarian",
		langCode: 'hu',
	},
	{
		id: 42,
		name: "Hebrew",
		langCode: 'he',
	},
	{
		id: 43,
		name: "Italian",
		langCode: 'it',
	},
	{
		id: 45,
		name: "Japanese",
		langCode: 'ja',
	},
	{
		id: 49,
		name: "Korean",
		langCode: 'ko',
	},
	{
		id: 50,
		name: "Latvian",
		langCode: 'lv',
	},
	{
		id: 51,
		name: "Lithuanian",
		langCode: 'lt',
	},
	{
		id: 85,
		name: "Macedonian",
		langCode: 'mk',
	},
	{
		id: 60,
		name: "Norwegian",
		langCode: 'nb',
	},
	{
		id: 65,
		name: "Polish",
		langCode: 'pl',
		tfidf: true,
	},
	{
		id: 66,
		name: "Portuguese",
		langCode: 'pt',
	},
	{
		id: 67,
		name: "Romanian",
		langCode: 'ro',
	},
	{
		id: 68,
		name: "Russian",
		langCode: 'ru',
	},
	{
		id: 71,
		name: "Serbian",
		langCode: 'sr',
	},
	{
		id: 73,
		name: "Slovak",
		langCode: 'sk',
	},
	{
		id: 74,
		name: "Vietnamese",
		langCode: 'en',
	},
	{
		id: 75,
		name: "Slovenian",
		langCode: 'sl',
	},
	{
		id: 77,
		name: "Spanish",
		langCode: 'es',
	},
	{
		id: 78,
		name: "Swedish",
		langCode: 'sv',
		tfidf: true,
	},
	{
		id: 80,
		name: "Thai",
		langCode: 'th',
	},
	{
		id: 83,
		name: "Turkish",
		langCode: 'tr',
	},
	{
		id: 84,
		name: "Ukrainian",
		langCode: 'uk',
	},


];
export default languages;